<template>
  <form class="form-horizontal">
    <alert type="info"><b>输入手机号进行搜索，点击下方搜索结果中正确的客户</b></alert>
    <div class="form-group">
      <label class="col-sm-2 control-label">手机</label>
      <div class="col-sm-10">
        <input
          type="text"
          class="form-control"
          placeholder="手机"
          v-model="user.profile.phone"
          @input="onPhoneInput"
        >
      </div>
    </div>
    
    <div class="form-group">
      <label class="col-sm-2 control-label">姓名</label>
      <div class="col-sm-10">
        <input
          type="text"
          class="form-control"
          placeholder="姓名"
          v-model="user.profile.name"
        >
      </div>
    </div>
    <div class="form-group">
      <label class="col-sm-2 control-label">地址</label>
      <div class="col-sm-10">
        <input
          type="text"
          class="form-control"
          placeholder="地址"
          v-model="user.profile.address"
        >
      </div>
    </div>
    <div class="form-group">
      <label class="col-sm-2 control-label">性别</label>
      <div class="col-sm-10">
        <select class="form-control" v-model="user.profile.sex">
          <option value="女">女</option>
          <option value="男">男</option>
        </select>
      </div>
    </div>
    <div class="form-group">
      <label class="col-sm-2 control-label">余额</label>
      <div class="col-sm-10">
        <input
          type="text"
          class="form-control"
          placeholder="余额"
          v-model="user.profile.balance"
        >
      </div>
    </div>
  </form>
</template>

<script>
export default {
  props: ['user'],
  methods: {
    onPhoneInput() {
      this.$emit('onPhoneInput', this.user.profile.phone)
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/forms/User.vue